

























































































import { mixins } from 'vue-class-component'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'
import { Component } from '@niknevis/vue-modules'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import CampaignItemPaymentMethods from '@/modules/campaign-item-payment/components/admin/CampaignItemPaymentMethods.vue'
import AvatarUploader from '@/modules/shared/components/shared/form/AvatarUploader.vue'
import { TicketStoreRequestModelInAdmin } from '@/modules/ticket/models/ticket-request.model'
import AdminUserSearch from '@/modules/user/components/admin/AdminUserSearch.vue'
import AdminDepartmentSearch from '@/modules/department/components/admin/AdminDepartmentSearch.vue'
import MediaUploader from '@/modules/media/components/shared/MediaUploader.vue'
import TicketStatusView from '@/modules/ticket/components/shared/TicketStatusView.vue'
import { Prop, Watch } from 'vue-property-decorator'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import AdminPredefinedSearch from '@/modules/predefined-answer/components/admin/AdminPredefinedSearch.vue'
import PersonSearch from '@/modules/common/person/components/PersonSearch.vue'
import { DepartmentIdModel } from '@/modules/department/models/department-resource.model'

@Component({
  components: {
    PersonSearch,
    AdminPredefinedSearch,
    BaseSelect,
    TicketStatusView,
    MediaUploader,
    AdminDepartmentSearch,
    AdminUserSearch,
    CampaignItemPaymentMethods,
    Modal,
    BaseButton,
    BaseInput,
    Toggle,
    AvatarUploader
  }
})
export default class AdminCreateTicketForm extends mixins<DialogMixin>(DialogMixin) {

  @Prop() ticket!: TicketStoreRequestModelInAdmin
  ticketMessage = this.ticket.message
  @Prop() isLoading!: boolean
  private isNew: boolean = false
  private predefinedAnswerSearchDefault: number[] = []
  private predefinedAnswer: string = ''
  departmentIdModel = DepartmentIdModel

  protected setProperty(key, value) {
    this.$set(this.ticket, key, value)
  }

  setPredefined(key, value) {
    this.predefinedAnswer = (value) ? value : ''
  }

  @Watch('predefinedAnswer')
  onPredefinedAnswerChange(newVal) {
    if (newVal !== '') {
      this.ticketMessage =
        (this.ticketMessage)
          ? `${this.ticketMessage} \n ${newVal}`
          : newVal
      this.predefinedAnswer = ''
    }
  }

  onSubmit() {
    this.ticket.message = this.ticketMessage
    this.$emit('submit', this.ticket)
  }
}
